<div class="dh-container">

  <div class="dh-card">

    <!-- Card header -->
    <!-- <div class="dh-card-header">
      <span class="dh-card-title">
        <i class="fas fa-hospital-user"></i> Nouvelle demande d'hospitalisation
      </span>
    </div> -->

    <!-- Card body -->
    <div class="dh-card-body">
      <div class="row g-3">

        <!-- Type hospitalisation -->
        <div class="col-md-4">
          <label class="dh-label required">Type hospitalisation</label>
          <ng-select [items]="itemsTypeHospitalisation" bindLabel="libelle" bindValue="id"
            [(ngModel)]="itemToSave.type_hospitalisation_id" [searchable]="true" [clearable]="true"
            placeholder="Sélectionnez..." (change)="onSelectTypeHospitalisation()">
          </ng-select>
        </div>

        <!-- Raison hospitalisation -->
        <div class="col-md-4">
          <label class="dh-label required">Raison</label>
          <ng-select [items]="itemsRaisonHospitalisation" bindLabel="libelle" bindValue="id"
            [(ngModel)]="itemToSave.raison_hospitalisation_id" [searchable]="true" [clearable]="true"
            placeholder="Sélectionnez..." (change)="onSelectRaisonHospitalisation()">
          </ng-select>
        </div>

        <!-- Type chambre (HM only) -->
        @if (selectedTypeHospitalisation.codification === 'HM') {
        <div class="col-md-4">
          <label class="dh-label required">Type chambre</label>
          <ng-select [items]="itemsTypeChambreHospitalisation" bindLabel="libelle" bindValue="id"
            [(ngModel)]="itemToSave.type_chambre_hospitalisation_id" [searchable]="true" [clearable]="true"
            placeholder="Sélectionnez..." (change)="onSelectTypeChambreHospitalisation()">
          </ng-select>
        </div>
        }

        <!-- Date entrée (HM) -->
        @if (selectedTypeHospitalisation.codification === 'HM') {
        <div class="col-md-4">
          <label class="dh-label required">Date entrée</label>
          <div class="dh-date-field">
            <input class="form-control dh-date-input" [owlDateTime]="dtEntree" [owlDateTimeTrigger]="dtEntree"
              [(ngModel)]="itemToSave.date_entree" name="date_entree" placeholder="Sélectionnez une date" readonly>
            <span class="dh-cal-trigger" [owlDateTimeTrigger]="dtEntree">
              <i class="fas fa-calendar-alt"></i>
            </span>
            <owl-date-time #dtEntree pickerType="calendar"></owl-date-time>
          </div>
        </div>
        }

        <!-- Durée prévisionnelle (HM or HC) -->
        @if (selectedTypeHospitalisation.codification === 'HM' || selectedTypeHospitalisation.codification === 'HC') {
        <div class="col-md-4">
          <label class="dh-label required">Durée prévisionnelle (jours)</label>
          <input mask="separator" type="text" class="form-control" [(ngModel)]="itemToSave.duree_demande"
            name="duree_demande" placeholder="Ex: 3">
        </div>
        }

        <!-- Date intervention (HC) -->
        @if (selectedTypeHospitalisation.codification === 'HC') {
        <div class="col-md-4">
          <label class="dh-label required">Date intervention</label>
          <div class="dh-date-field">
            <input class="form-control dh-date-input" [owlDateTime]="dtIntervention"
              [owlDateTimeTrigger]="dtIntervention" [(ngModel)]="itemToSave.date_intervention" name="date_intervention"
              placeholder="Sélectionnez une date" readonly>
            <span class="dh-cal-trigger" [owlDateTimeTrigger]="dtIntervention">
              <i class="fas fa-calendar-alt"></i>
            </span>
            <owl-date-time #dtIntervention pickerType="calendar"></owl-date-time>
          </div>
        </div>
        }

        <!-- Heures observation (MEO) -->
        @if (selectedTypeHospitalisation.codification === 'MEO') {
        <div class="col-md-4">
          <label class="dh-label required">Heure début observation</label>
          <input type="time" class="form-control" [(ngModel)]="itemToSave.heure_debut_observation"
            name="heure_debut_observation">
        </div>
        <div class="col-md-4">
          <label class="dh-label required">Heure fin observation</label>
          <input type="time" class="form-control" [(ngModel)]="itemToSave.heure_fin_observation"
            name="heure_fin_observation">
        </div>
        }

        <!-- Fichier joint -->
        <div class="col-md-4">
          <label class="dh-label">Fichier joint</label>
          <input (change)="uploadFile($event)" type="file" class="form-control" id="fichier1" name="fichier1">
        </div>

        <!-- Proforma (HC) -->
        @if (selectedTypeHospitalisation.codification === 'HC') {
        <div class="col-12">
          <div class="dh-proforma">
            <div class="dh-proforma-header">
              <i class="fas fa-file-invoice me-1"></i> Facture proforma d'intervention
            </div>
            <form class="dh-proforma-form" (ngSubmit)="onAddItemToList()">
              <div class="row g-2 align-items-end">
                <div class="col-md-6">
                  <label class="dh-label">Libellé</label>
                  <input type="text" class="form-control form-control-sm" [(ngModel)]="itemToAdd.libelle"
                    name="libelle">
                </div>
                <div class="col-md-2">
                  <label class="dh-label">Quantité</label>
                  <input mask="separator" type="text" class="form-control form-control-sm"
                    [(ngModel)]="itemToAdd.quantite" name="quantite">
                </div>
                <div class="col-md-2">
                  <label class="dh-label">Prix unitaire</label>
                  <input mask="separator" type="text" class="form-control form-control-sm"
                    [(ngModel)]="itemToAdd.prix_unitaire" name="prix_unitaire">
                </div>
                <div class="col-md-2">
                  <button type="submit" class="btn btn-primary btn-sm w-100">
                    <i class="fas fa-plus"></i> Ajouter
                  </button>
                </div>
              </div>
            </form>

            <div class="table-responsive mt-2">
              <table class="table table-sm table-hover table-bordered mb-0">
                <thead class="table-light">
                  <tr>
                    <th>#</th>
                    <th>Libellé</th>
                    <th class="text-center">Qté</th>
                    <th class="text-end">Prix unit.</th>
                    <th class="text-end">Total</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  @for (item of itemsDetailProforma; track $index) {
                  <tr>
                    <td>{{ $index + 1 }}</td>
                    <td>{{ item.libelle }}</td>
                    <td class="text-center">{{ item.quantite | IntegerFormatPipe }}</td>
                    <td class="text-end">{{ item.prix_unitaire | IntegerFormatPipe }}</td>
                    <td class="text-end fw-semibold">{{ item.total | IntegerFormatPipe }}</td>
                    <td class="text-center">
                      <button (click)="itemsDetailProforma.splice($index, 1)" class="btn btn-danger btn-sm py-0">
                        <i class="fas fa-trash-alt"></i>
                      </button>
                    </td>
                  </tr>
                  }
                  @if (itemsDetailProforma?.length) {
                  <tr class="table-light">
                    <td colspan="4" class="text-end fw-bold">Total</td>
                    <td class="text-end fw-bold text-primary">{{ getTotal() | IntegerFormatPipe }}</td>
                    <td></td>
                  </tr>
                  }
                  @if (!itemsDetailProforma?.length) {
                  <tr>
                    <td colspan="6" class="text-center text-muted py-3">
                      <i class="fas fa-info-circle me-1"></i>Aucun élément ajouté
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
        }

        <!-- Commentaires -->
        <div class="col-12">
          <label class="dh-label">Commentaires</label>
          <textarea class="form-control" rows="2" [(ngModel)]="itemToSave.commentaire" name="commentaire"
            placeholder="Informations complémentaires..."></textarea>
        </div>

      </div>
    </div>

    <!-- Submit -->
    <div class="dh-card-footer">
      <button class="dh-submit-btn" (click)="confirmSaveItem()" [disabled]="isProcessComplete">
        @if (isProcessComplete) {
        <i class="fas fa-check-circle me-2"></i>Demande soumise
        } @else {
        <i class="fas fa-paper-plane me-2"></i>Envoyer la demande d'hospitalisation
        }
      </button>
    </div>

  </div>

</div>